import { actionTypes } from '../actionTypes';
import { ISubscriptionReportState } from '../../model/subscriptionReports';
import {
  filterAllUsersData,
  filterArchivedData,
  filterAllUserNoRRData,
  filterAllSubscriptionsData,
  filterSubscriptionsByDateData,
  filterExpiredUsersData,
  filterExpire30DaysData,
  filterExpire120DaysData,
  filterAllTSLiveReportData,
  filterSpecialBillingReportData,
  filterIrvineAccountsData,
  filterRedyRefData,
  filterCancelledUserReportData,
  filterSubscriptionsByDate,
  filterExpiredUserDataByFilter

} from './subscriptionReportsFilters'

export const supscriptionReportsReducer = (state: ISubscriptionReportState[] = [], action: any) => {
  switch (action.type) {
    case actionTypes.LOAD_SUBSCRIPTION_REPORTS_SUCCESS:
      return {
        ...state,
        AllUsers: filterAllUsersData(action.payload)
      }
    case actionTypes.LOAD_SUBSCRIPTION_REPORTS_ARCHIVED:
      return {
        ...state,
        Archived: filterArchivedData(action.payload)
      }
    case actionTypes.LOAD_SUBSCRIPTION_REPORTS_ALL_USERS_NO_RR:
      return {
        ...state,
        AllUserNoRR: filterAllUserNoRRData(action.payload),
      }
    case actionTypes.LOAD_SUBSCRIPTION_REPORTS_ALL_SUBSCRIPTIONS:
      return {
        ...state,
        AllSubscriptions: filterAllSubscriptionsData(action.payload),
      }
    case actionTypes.LOAD_SUBSCRIPTION_REPORTS_SUBSCRIPTIONS_DATE:
      return {
        ...state,
        SubscriptionsFilteredByDate: filterSubscriptionsByDateData(action.payload),
        SubscriptionsByDate: filterSubscriptionsByDateData(action.payload)
      }
    case actionTypes.LOAD_SUBSCRIPTION_REPORTS_EXPIRED_USERS:
      return {
        ...state,
        ExpiredUsers: filterExpiredUsersData(action.payload),
        filterExpiredUsers: filterExpiredUsersData(action.payload)
      }
    case actionTypes.LOAD_SUBSCRIPTION_REPORTS_30_DAYS:
      return {
        ...state,
        ExpiredIn30Days: filterExpire30DaysData(action.payload),
      }
    case actionTypes.LOAD_SUBSCRIPTION_REPORTS_120_DAYS:
      return {
        ...state,
        ExpiredIn120Days: filterExpire120DaysData(action.payload)
      }
    case actionTypes.LOAD_SUBSCRIPTION_REPORTS_ALL_TSLIVE:
      return {
        ...state,
        AllTSLiveReport: filterAllTSLiveReportData(action.payload),
      }
    case actionTypes.LOAD_SUBSCRIPTION_REPORTS_ALL_SPECIAL_BILLING:
      return {
        ...state,
        SpecialBillingReports: filterSpecialBillingReportData(action.payload),
      }
    case actionTypes.LOAD_SUBSCRIPTION_REPORTS_IRVINE_ACCOUNTS:
      return {
        ...state,
        ListOfIrvineAccounts: filterIrvineAccountsData(action.payload),
      }
    case actionTypes.LOAD_SUBSCRIPTION_REPORTS_REDYREF_ACCOUNTS:
      return {
        ...state,
        ListOfRedyRefAccounts: filterRedyRefData(action.payload),
      }
    case actionTypes.LOAD_SUBSCRIPTION_REPORTS_CANCELLED_USER:
      return {
        ...state,
        CancelledUsersReport: filterCancelledUserReportData(action.payload),
      }
    // filter date by issue
    case actionTypes.LOAD_SUBSCRIPTION_REPORTS_SUBSCRIPTIONS_BY_DATE:
      return {
        ...state,
        SubscriptionsByDate: filterSubscriptionsByDate(state, action.payload.date),
      }

    case actionTypes.LOAD_EXPIRED_USER_REPORTS__BY_FILTER:
    return {
      ...state,
      filterExpiredUsers: filterExpiredUserDataByFilter(state, action.filterType),
    }
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/store/subscriptionReports/reducer.ts